import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import {
  changeUpdate,
  serviceWorkerRegistrationSelector,
  serviceWorkerUpdatedSelector,
} from '../state';
import DialogFlexSales from './DialogFlexSales';

const UpdateControl = () => {
  const updateAvailable = useSelector(serviceWorkerUpdatedSelector);
  const registration = useSelector(serviceWorkerRegistrationSelector);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();

  const handleClose = useCallback(() => {
    const serviceWorker = registration?.waiting || registration?.active;
    if (serviceWorker) {
      serviceWorker.postMessage({ type: 'SKIP_WAITING' });
      serviceWorker.addEventListener('statechange', e => {
        if ((e.target as ServiceWorker | null)?.state === 'activated') {
          dispatch(changeUpdate(registration));
          window.sessionStorage.clear();
          window.location.reload();
        }
      });
      if (serviceWorker.state === 'activated') {
        dispatch(changeUpdate(registration));
        window.sessionStorage.clear();
        window.location.reload();
      }
    }
  }, [dispatch, registration]);

  useEffect(() => {
    navigator.serviceWorker.getRegistration().then(registration => {
      registration?.update();
    });
  }, [location]);

  return (
    <DialogFlexSales
      open={updateAvailable}
      onClose={handleClose}
      aria-describedby="alert-dialog-update-description"
      dialogTitle={t('alerts.newVersion.title')}
      subtitle={t('alerts.newVersion.subtitle')}
      icon={<SystemUpdateAltIcon />}
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-update-description">
          {t('alerts.newVersion.body')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('alerts.newVersion.refreshAction')}</Button>
      </DialogActions>
    </DialogFlexSales>
  );
};

export default UpdateControl;
